exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._2-spm5nMFu7aZkKozlbhkK {\n  padding: 1.5rem;\n}\n._2Q66eFw7Bka-rgyQn-CmQ1 {\n  padding: 0.3rem;\n}\n._2Q66eFw7Bka-rgyQn-CmQ1 .label {\n  margin-right: 0.3rem;\n}\n._3_0acA9ivN_SB8gQ3HQ4sp {\n  display: inline-block;\n  font-weight: bold;\n  padding: 0 0.3rem;\n  vertical-align: middle;\n}\n._2U-hkPAotxiLOI0WJwfn8r {\n  padding: 1.5rem 0.5rem;\n}\n._2U-hkPAotxiLOI0WJwfn8r .btn {\n  margin-right: 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"lobby": "_2-spm5nMFu7aZkKozlbhkK",
	"player": "_2Q66eFw7Bka-rgyQn-CmQ1",
	"player-name": "_3_0acA9ivN_SB8gQ3HQ4sp",
	"buttons": "_2U-hkPAotxiLOI0WJwfn8r"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/stylus-loader!./src/css/lobby.styl
 ** module id = 263
 ** module chunks = 0
 **/